module.exports = __webpack_public_path__ + "static/media/products-header-image.a1dddc97.png";